export const SMALL_TIER = 'small';
export const MEDIUM_TIER = 'medium';
export const LARGE_TIER = 'large';
export const ENTERPRISE_TIER = 'enterprise';
export const LARGE_ENTERPRISE_TIER = 'large enterprise';
export const EXTRA_LARGE_ENTERPRISE_TIER = 'xl enterprise';

export const tiers = {
  [SMALL_TIER]: SMALL_TIER,
  [MEDIUM_TIER]: MEDIUM_TIER,
  [LARGE_TIER]: LARGE_TIER,
  [ENTERPRISE_TIER]: ENTERPRISE_TIER,
  [LARGE_ENTERPRISE_TIER]: LARGE_ENTERPRISE_TIER,
  [EXTRA_LARGE_ENTERPRISE_TIER]: EXTRA_LARGE_ENTERPRISE_TIER,
};

export const tierColors = {
  blue: 'blue',
  bronze: 'bronze',
  silver: 'silver',
  gold: 'gold',
  platinum: 'platinum',
  purple: 'purple',
};

export const tierSizeFormattedString = {
  [SMALL_TIER]: 'Small',
  [MEDIUM_TIER]: 'Medium',
  [LARGE_TIER]: 'Large',
  [ENTERPRISE_TIER]: 'Enterprise',
  [LARGE_ENTERPRISE_TIER]: 'Large Enterprise',
  [EXTRA_LARGE_ENTERPRISE_TIER]: 'XL Enterprise',
};
export const tierSizeFormattedShortString = {
  [SMALL_TIER]: 'S',
  [MEDIUM_TIER]: 'M',
  [LARGE_TIER]: 'L',
  [ENTERPRISE_TIER]: 'E',
  [LARGE_ENTERPRISE_TIER]: 'LE',
  [EXTRA_LARGE_ENTERPRISE_TIER]: 'XLE',
};

export const tierColorToSize = {
  [tierColors.blue]: tiers[SMALL_TIER],
  [tierColors.bronze]: tiers[MEDIUM_TIER],
  [tierColors.silver]: tiers[LARGE_TIER],
  [tierColors.gold]: tiers[ENTERPRISE_TIER],
  [tierColors.platinum]: tiers[LARGE_ENTERPRISE_TIER],
  [tierColors.purple]: tiers[EXTRA_LARGE_ENTERPRISE_TIER],
};
